import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAdmin } from "../../store/user/user.selector.js";

/**
 * Protects admin-only routes. Redirects non-admins to home.
 */
export default function AdminRoute({ children }) {
  const isAdmin = useSelector(selectIsAdmin);

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
